import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { storeWithExpiration } from '../../utils/common';
import {
  clearFieldsForSku,
  enableDatasetVersion,
  deleteDatasetVersion,
  fetchDatasetRecordCount,
  fetchDatasetsById,
  fetchFieldsetsById,
  fetchVersions,
  getFieldsForSku,
  listFields,
  resetNewListBooleans,
} from '../../actions/data';
import { listAccounts, fetchPlatforms } from '../../actions/superadmin';
import AdminDatasets from './AdminDatasets';

export class AdminDatasetsContainer extends React.Component {
  static propTypes = {
    accounts: PropTypes.object.isRequired,
    dataSetsSummary: PropTypes.object.isRequired,
    deleteVersionAction: PropTypes.func.isRequired,
    enableVersionAction: PropTypes.func.isRequired,
    fetchDatasetRecordCountAction: PropTypes.func.isRequired,
    fetchDatasetsByIdAction: PropTypes.func.isRequired,
    fetchFieldsetsByIdAction: PropTypes.func.isRequired,
    fetchPlatformsAction: PropTypes.func.isRequired,
    fetchVersionsAction: PropTypes.func.isRequired,
    fieldSetsSummary: PropTypes.object.isRequired,
    listAllAccountsAction: PropTypes.func.isRequired,
    recordsSummary: PropTypes.object.isRequired,
    resetBooleansAction: PropTypes.func.isRequired,
    versionsSummary: PropTypes.object.isRequired,
  };

  componentWillMount = () => {
    const { listAllAccountsAction, fetchPlatformsAction, fetchDatasetsByIdAction } = this.props;
    const token = storeWithExpiration.get('token');
    const prom = new Promise(resolve => {
      listAllAccountsAction(token, resolve);
    });
    prom
      .then(() => {
        this.props.accounts.map(account => fetchDatasetsByIdAction(account.id, token));
      })
      .then(() => {
        fetchPlatformsAction();
      });
  };

  performEnableVersion = (datasetId, versionId) => {
    const { enableVersionAction, fetchVersionsAction } = this.props;
    const token = storeWithExpiration.get('token');
    const prom = new Promise(resolve => {
      enableVersionAction(token, datasetId, versionId, resolve);
    });
    prom.then(() => {
      fetchVersionsAction(datasetId, token);
    });
  };

  performDeleteVersion = (datasetId, versionId) => {
    const { deleteVersionAction, fetchVersionsAction } = this.props;
    const token = storeWithExpiration.get('token');
    // eslint-disable-next-line
    if (window.confirm('Are you sure you want to delete this version?')) {
      const prom = new Promise(resolve => {
        deleteVersionAction(token, datasetId, versionId, resolve);
      });
      prom.then(() => {
        fetchVersionsAction(datasetId, token);
      });
    }
  };

  render() {
    const {
      accounts,
      dataSetsSummary,
      fieldSetsSummary,
      recordsSummary,
      versionsSummary,
      fetchDatasetsByIdAction,
      fetchDatasetRecordCountAction,
      fetchFieldsetsByIdAction,
      fetchVersionsAction,
      resetBooleansAction,
    } = this.props;

    return (
      <div className="container">
        <h1>Overview of Customer Datasets</h1>
        <AdminDatasets
          accounts={accounts}
          dataSetsSummary={dataSetsSummary}
          enableVersionFunction={this.performEnableVersion}
          deleteVersionFunction={this.performDeleteVersion}
          fetchDatasetRecordCountFunction={fetchDatasetRecordCountAction}
          fetchDatasetsByIdFunction={fetchDatasetsByIdAction}
          fetchFieldsetsByIdFunction={fetchFieldsetsByIdAction}
          fetchVersionsFunction={fetchVersionsAction}
          fieldSetsSummary={fieldSetsSummary}
          isAdminPage
          recordsSummary={recordsSummary}
          resetBooleansAction={resetBooleansAction}
          versionsSummary={versionsSummary}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { data, dialog, superadmin } = state;
  const dataSetsSummary = data.get('dataSetsSummary');
  const accounts = superadmin.get('accounts');
  const fieldSetsSummary = data.get('fieldSetsSummary');
  const recordsSummary = data.get('recordsSummary');
  const versionsSummary = data.get('versionsSummary');
  const platforms = superadmin.get('platforms');
  const skuFields = data.get('fields');
  const currentSkuFields = data.get('currentSkuFields');
  return {
    accounts,
    dataSetsSummary,
    fieldSetsSummary,
    dialog,
    recordsSummary,
    versionsSummary,
    platforms,
    skuFields,
    currentSkuFields,
  };
}

export default connect(mapStateToProps, {
  clearFieldsForSkuAction: clearFieldsForSku,
  enableVersionAction: enableDatasetVersion,
  deleteVersionAction: deleteDatasetVersion,
  fetchDatasetRecordCountAction: fetchDatasetRecordCount,
  fetchDatasetsByIdAction: fetchDatasetsById,
  fetchFieldsetsByIdAction: fetchFieldsetsById,
  fetchPlatformsAction: fetchPlatforms,
  fetchVersionsAction: fetchVersions,
  getFieldsForSkuAction: getFieldsForSku,
  listAllAccountsAction: listAccounts,
  listFieldsAction: listFields,
  resetBooleansAction: resetNewListBooleans,
})(AdminDatasetsContainer);
